import { render, staticRenderFns } from "./statementDiscount.vue?vue&type=template&id=03b7d5a2"
import script from "./statementDiscount.ts?vue&type=script&lang=js&external"
export * from "./statementDiscount.ts?vue&type=script&lang=js&external"
import style0 from "./statementDiscount.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports